// Use environment variable for API base URL
// Build process sets REACT_APP_API_BASE correctly for each environment

// Debug logging to see what's happening
console.log('🔍 [API_BASE_DEBUG] Environment variables:');
console.log('  - REACT_APP_API_BASE:', process.env.REACT_APP_API_BASE);
console.log('  - REACT_APP_ENVIRONMENT:', process.env.REACT_APP_ENVIRONMENT);
console.log('  - NODE_ENV:', process.env.NODE_ENV);

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8080";

console.log('🔍 [API_BASE_DEBUG] Final API_BASE value:', API_BASE);
console.log('🔍 [API_BASE_DEBUG] Current window.location:', window.location.href);

export default API_BASE; 